import { render } from "./AboutS13.vue?vue&type=template&id=0954ec4e&scoped=true"
import script from "./AboutS13.vue?vue&type=script&lang=js"
export * from "./AboutS13.vue?vue&type=script&lang=js"

import "./AboutS13.vue?vue&type=style&index=0&id=0954ec4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0954ec4e"]])

export default __exports__